import styled from 'styled-components/macro';

export const StyledPage = styled.div`
  border-radius: 8px;
  max-width: 1250px;
  margin: 0 auto;
  padding: 0 20px;
`;
